import { useAuth } from '@/contexts/ContextoAuth';
import type { FlujoRetroalimentacion } from '../tipos';
import { useRetroalimentacion } from './useRetroalimentacion';

export function useFlujoEfectivoRetroalimentacion(): { flujo: FlujoRetroalimentacion; esSuperAdmin: boolean } {
  const { user } = useAuth();
  const { flujoActivo } = useRetroalimentacion();
  const esSuperAdmin = Boolean(user?.esSuperAdminSenciyo);

  return {
    esSuperAdmin,
    flujo: flujoActivo === 'resultados' && !esSuperAdmin ? 'estado_animo' : flujoActivo,
  };
}
